











import moment from 'moment'
import { Component, Vue, Prop } from 'vue-property-decorator'
import LcArticleListItem from './LcArticleListItem.vue'
import { ArticleList, ArticleBase } from '@/types/articles.type'

@Component({components: {LcArticleListItem}})
class LcArticleList extends Vue {
  @Prop(String) type!: string

  get sortedArticles () {
    return this.$store.state.status[this.type] as ArticleBase[]
  }
}
export default LcArticleList
